import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-forward",
  "use": "icon-si-glyph-arrow-forward-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-si-glyph-arrow-forward\">    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->    <title>1182</title>        <defs></defs>    <g stroke=\"none\" stroke-width=\"1\">        <path d=\"M15.584,5.988 L10.344,1.343 C9.94,0.933 9.465,0.864 9.061,1.275 L9.061,4.407 C8.965,4.406 8.883,4.406 8.834,4.406 C3.884,4.406 0.084,7.969 0.084,12.816 C0.084,14.504 0.85,13.889 1.167,13.3 C2.668,10.52 5.434,8.623 8.872,8.623 C8.913,8.623 8.982,8.624 9.06,8.624 L9.06,11.689 C9.464,12.099 9.989,12.05 10.343,11.757 L15.583,7.474 C15.988,7.064 15.988,6.399 15.584,5.988 L15.584,5.988 Z\" />    </g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-forward.svg
// module id = Lca3
// module chunks = 62